import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { SearchInput } from '@reveni-io/reveni-ui'

import { minSearchChars, searchDebounceMs, searchPlaceholders } from './constants'
import * as Styles from './styles'

const ProductsSearchInput = ({ groupBy, onSearch, initialValue = '' }) => {
  const { t } = useTranslation()
  const [searchValue, setSearchValue] = useState(initialValue)

  const handleChange = value => {
    setSearchValue(value)
    if (!value) {
      onSearch('')
    }
  }

  return (
    <Styles.Container>
      <SearchInput
        fullWidth
        placeholder={t(searchPlaceholders[groupBy])}
        onSearch={onSearch}
        value={searchValue}
        onChangeValue={handleChange}
        minCharsToTrigger={minSearchChars}
        searchTimeout={searchDebounceMs}
      />
    </Styles.Container>
  )
}

export default ProductsSearchInput
